import { Component } from 'react';
import { bool, node, string, func } from 'prop-types';

class MeetingProtection extends Component {
  constructor(props) {
    super(props);
    window.addEventListener('beforeunload', this.handleBeforeUnload, false);
  }

  componentWillUnmount() {
    const {
      hasMeeting,
      consultGuid,
      meetingEnd,
    } = this.props;
    window.removeEventListener('beforeunload', this.handleBeforeUnload, false);
    if (hasMeeting) {
      meetingEnd(consultGuid);
    }
  }

  handleBeforeUnload = (e) => {
    const {
      message,
      hasMeeting,
      enabled,
    } = this.props;
    if (!hasMeeting || !enabled) { return null; }

    e.returnValue = message;
    return message;
  }

  render() {
    return this.props.children;
  }
}

const MapStateProps = {
  consultGuid: string,
  hasMeeting: bool.isRequired,
};

const MapDispatchProps = {
  meetingEnd: func.isRequired,
};

MeetingProtection.propTypes = {
  children: node.isRequired,
  enabled: bool.isRequired,
  message: string.isRequired,
  ...MapStateProps,
  ...MapDispatchProps,
};

MeetingProtection.defaultProps = {
  message: 'Are you sure you want to leave while you are in a consult?',
};

export default MeetingProtection;
